export default __webpack_public_path__ + "static/media/campaign-play.84306a55.svg";